import React, { useEffect, useRef, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { Swiper, SwiperSlide } from 'swiper/react'
import { Autoplay, Navigation } from 'swiper/modules'
import 'swiper/css'
import 'swiper/css/navigation'
import { B1, Location } from '../../../assests/ExportImageIcon'
// B2/B3 were only used by the commented-out static `blogs` mock below.
import SaveToWishlistButton from '../../../componants/wishlist/SaveToWishlistButton'
import useIndividualWishlistItems, { wishlistItemKey } from '../../../componants/wishlist/useIndividualWishlistItems'
import service from '../../../services/service'
import endpoints from '../../../services/endpoints'

// Static fallback — kept for reference. Real events (unfiltered, latest
// first) come from GET /customer_events/ below.
// const blogs = [
//     { img: B1, title: 'Top 10 Hill Stations to Visit This Summer', author: 'finzo', date: '21 April, 2026' },
//     { img: B2, title: 'A Traveler\'s Guide to Booking Cheap Flights', author: 'finzo', date: '18 April, 2026' },
//     { img: B3, title: 'Best Beaches in Goa You Shouldn\'t Miss', author: 'finzo', date: '15 April, 2026' },
//     { img: B1, title: '5 Tips to Plan a Budget-Friendly Trip', author: 'finzo', date: '10 April, 2026' },
//     { img: B2, title: 'Why Rishikesh is the Perfect Adventure Getaway', author: 'finzo', date: '05 April, 2026' },
//     { img: B3, title: 'How to Choose the Right Travel Insurance', author: 'finzo', date: '01 April, 2026' },
// ]

const formatEventDateTime = (value) => {
    if (!value) return ''
    const date = new Date(value.replace(' ', 'T'))
    if (Number.isNaN(date.getTime())) return value
    return date.toLocaleDateString('en-US', { day: '2-digit', month: 'short', year: 'numeric' })
}

const Events = () => {
    const navigate = useNavigate()
    const prevRef = useRef(null)
    const nextRef = useRef(null)
    const swiperRef = useRef(null)
    const [events, setEvents] = useState([])
    const { individualId, savedMap } = useIndividualWishlistItems()

    useEffect(() => {
        service
            .get(endpoints.customerEvents.list, {}, { silent: true })
            .then(({ data }) => setEvents(data.data || []))
            .catch(() => {})
    }, [])

    useEffect(() => {
        const swiper = swiperRef.current
        if (!swiper) return
        swiper.params.navigation = {
            ...swiper.params.navigation,
            prevEl: prevRef.current,
            nextEl: nextRef.current,
        }
        swiper.navigation.init()
        swiper.navigation.update()
    }, [])

    return (
        <>
            <section className='ourLatestBlog popularDestination paddingCmn'>
                <div className='container'>
                    <div className='row'>
                        <div className='col-md-12'>
                            <div className='secHeadArea'>
                                <div className='mainHead'>Your next event trip</div>
                                <Link to="/event-list">View All</Link>
                            </div>
                        </div>
                        <div className="col-md-12">
                            <div className="carousel">
                                <Swiper
                                    modules={[Navigation, Autoplay]}
                                    spaceBetween={20}
                                    slidesPerView={1.2}
                                    loop
                                    autoplay={{ delay: 2000, disableOnInteraction: false, pauseOnMouseEnter: true }}
                                    onSwiper={(swiper) => { swiperRef.current = swiper }}
                                    breakpoints={{
                                        576: { slidesPerView: 1 },
                                        768: { slidesPerView: 2 },
                                        992: { slidesPerView: 3 },
                                        1200: { slidesPerView: 3 },
                                    }}
                                >
                                    {events.map((event) => (
                                        <SwiperSlide key={event.id} className="p-3 me-4 bg-white rounded-3" onClick={() => navigate(`/event-detail/${event.id}`)}>
                                            <div className='slidePart'>
                                                <img src={event.cover_image || B1} alt={event.name} className='eventMainImage' />
                                                    <SaveToWishlistButton
                                                        className="hotelCard__wishlist eventWishlist"
                                                        item={{
                                                            recordModule: 'event',
                                                            recordId: event.id,
                                                            recordName: event.name,
                                                            imageUrl: event.cover_image,
                                                        }}
                                                        preSavedItemId={savedMap.get(wishlistItemKey('event', event.id))}
                                                        preSavedWishlistId={individualId}
                                                    />

                                                <div className="blogContent">
                                                    <div> {event.category_name} | {formatEventDateTime(event.start_date_time)}</div>
                                                    <div className="flex-column text-end"> <div >
                                                        {event.artist_name}
                                                    </div>
                                                        <div>
                                                            {event.start_price ? `₹${Number(event.start_price).toLocaleString('en-IN')}` : ''}
                                                        </div> </div>

                                                </div>

                                                <div className='blogTitle mt-0'>{event.name}</div>
                                                <div className='blogAuthor mt-1'><img src={Location} alt="" />{event.venue_name}</div>
                                            </div>
                                        </SwiperSlide>
                                    ))}
                                </Swiper>
                                {/* <button type="button" className="carouselNav carouselNav-prev" ref={prevRef} aria-label="Previous">&#8249;</button>
                                <button type="button" className="carouselNav carouselNav-next" ref={nextRef} aria-label="Next">&#8250;</button> */}
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default Events;
